import { Injectable } from '@angular/core'
import { RegionalApiClientSetupService } from '@ftr/api-regional'
import { ApiClient } from '@ftr/api-shared'
import { Uuid } from '@ftr/contracts/type/shared'
import { ApiResult, mapData } from '@ftr/foundation'
import { AudioSegmentWithSttDto, AudioSegmentWithSttSchema } from '@ftr/regional-api-contracts'
import { switchMap } from 'rxjs'
import { RealTimeAudioSegmentWithSttRemarks } from '../../types'
import { utterancesToRemarks } from '../../utils'

@Injectable({
  providedIn: 'root',
})
export class RealTimeAudioSegmentSttService extends RegionalApiClientSetupService {
  override regionalApiPath = 'audio-segment'

  getAudioSegmentWithSttRemarks(
    courtSystemId: Uuid,
    audioSegmentId: Uuid,
    canReadStt: boolean,
  ): ApiResult<RealTimeAudioSegmentWithSttRemarks> {
    return canReadStt
      ? this.regionalApiClient(this.regionalApiPath, courtSystemId).pipe(
          switchMap(apiClient => {
            return this.getAudioSegmentWithStt(apiClient, courtSystemId, audioSegmentId).pipe(
              mapData(({ id, showSpeakers, utterances, speakers, lastEdited }) => {
                return {
                  id,
                  showSpeakers,
                  remarks: utterancesToRemarks(utterances, speakers),
                  lastEdited: lastEdited ?? undefined,
                }
              }),
            )
          }),
        )
      : ApiResult.success({ id: audioSegmentId, remarks: [], showSpeakers: false })
  }

  private getAudioSegmentWithStt(
    apiClient: ApiClient,
    courtSystemId: Uuid,
    audioSegmentId: Uuid,
  ): ApiResult<AudioSegmentWithSttDto> {
    return apiClient.get({
      path: `${audioSegmentId}/stt`,
      headers: { courtSystemId },
      responseBodyParser: AudioSegmentWithSttSchema,
    })
  }
}
